/* eslint-disable object-curly-spacing */
/* eslint-disable no-undef */
/* eslint-disable own-handles */
/* eslint-disable no-innerhtml-assign */
/* eslint-disable consistent-method-names */
/* eslint-disable no-jsdoc */
define(['lodash/core'], function(_) {
    'use strict';

    function isArray(object) {
        return _.isArray(object);
    }

    /**
     * @ignore
     * Consider NULL as not an object.
     * @param {*} val
     * @return {Boolean}
     */
    function isObject(val) {
        return _.isObject(val);
    }

    /**
     * @ignore
     * Consider NaN and Infinite as not a number.
     * @param {*} val
     * @return {Boolean}
     */
    function isValidNumber(val) {
        return _.isFinite(val);
    }

    /**
     * @ignore
     * @param {*} val
     * @return {Boolean}
     */
    function isNonEmptyString(val) {
        return _.isString(val) && val.length > 0;
    }

    /**
     * @ignore
     * Used instead of Number.isNaN
     * @param {*} val
     * @return {Boolean}
     */
    function numberIsNaN(val) {
        return _.isNaN(val);
    }

    /**
     * @ignore
     * Returns TRUE is the value is not undefined, null or NaN.
     * @param {*} val
     * @return {Boolean}
     */
    function isValidValue(val) {
        return val !== undefined && val !== null && !numberIsNaN(val);
    }

    /**
     * @ignore
     * Returns an function that check if a value passed as argument is an instance of an specific class.
     * @param {Object} classObject
     * @return {Function}
     */
    function createInstanceChecker(classObject) {
        return function(val) {
            return val instanceof classObject;
        };
    }

    function cloneProperties(object, clonedObject) {
        var property;
        for (property in object) {
            if (object.hasOwnProperty(property)) {
                if (isArray(object[property])) {
                    clonedObject[property] = object[property].slice(0);
                } else if (typeof object[property] === 'object') {
                    clonedObject[property] = {};
                    cloneProperties(object[property], clonedObject[property]);
                } else {
                    clonedObject[property] = object[property];
                }
            }
        }
    }

    function getValueOrEmptyObject(value) {
        return value === undefined ? {} : value;
    }

    function addNewField(result, field, newFields) {
        var property;
        result[field] = getValueOrEmptyObject(result[field]);
        for (property in newFields[field]) {
            if (newFields[field].hasOwnProperty(property)) {
                result[field][property] = newFields[field][property];
            }
        }
    }

    function convertToLatLng(value) {
        var convertedValue;
        if (value instanceof L.LatLng) {
            convertedValue = value;
        } else if (isArray(value)) {
            convertedValue = L.latLng(value);
        } else if (value && value.lat && value.lon) {
            convertedValue = L.latLng([value.lat, value.lon]);
        } else if (value && value.lat && value.lng) {
            convertedValue = L.latLng([value.lat, value.lng]);
        }
        return convertedValue;
    }

    function extend(obj, src) {
        var key;
        for (key in src) {
            if (src.hasOwnProperty(key)) {
                obj[key] = src[key];
            }

        }
        return obj;
    }

    return {
        isArray: isArray,
        isEqual: _.isEqual,
        isObject: isObject,
        isString: _.isString,
        isValidNumber: isValidNumber,
        isValidValue: isValidValue,
        isNonEmptyString: isNonEmptyString,
        createInstanceChecker: createInstanceChecker,
        convertToLatLng: convertToLatLng,

        addFields: function(newFields, defaultFields) {
            var field;
            var result = defaultFields || this.defaultFields || {};
            for (field in newFields) {
                if (newFields.hasOwnProperty(field)) {
                    addNewField(result, field, newFields);
                }
            }
            return result;
        },

        clone: function(object) {
            var clonedObject = {};
            cloneProperties(object, clonedObject);
            return clonedObject;
        },

        encodeQuery: function(query) {
            return encodeURIComponent(query);
        },

        encodeStringForRegex: function(value) {
            return value.replace(/[-[\]/{}()*+?.\\^$|]/g, '\\$&');
        },
        extend: extend,

        /**
         * @param {Object} sourceObj
         * @param {String} deprecatedPropertyName
         * @param {String} deprecatedPropertyReplacement
         */
        addDeprecatedProperty: function(sourceObj, deprecatedPropertyName, deprecatedPropertyReplacement) {
            Object.defineProperty(sourceObj, deprecatedPropertyName, {
                get: function() {
                    console.warn('Usage of ' + deprecatedPropertyName +
                        ' property is deprecated. Please use ' + deprecatedPropertyReplacement + ' property.');
                    return this[deprecatedPropertyReplacement];
                }
            });
        },

        pointRegex: /(-?\d+(?:\.\d+)?)(?:\s+|\s*,\s*)(-?\d+(?:\.\d+)?)/,

        circleRegex: /circle\((-?\d+(?:\.\d+)?)\s*,\s*(-?\d+(?:\.\d+)?)\s*,\s*(\d+)\)/,

        /**
         * @ignore
         * Returns a function, that, as long as it continues to be invoked, will not
         * be triggered. The function will be called after it stops being called for
         * N milliseconds.
         * @param {Object} context
         * @param {Function} func
         * @param {Number} wait
         * @return {Function}
         */
        debounce: function(context, func, wait) {
            var timeout;
            return function() {
                var later = function() {
                    timeout = null;
                    func.apply(context, arguments);
                };
                clearTimeout(timeout);
                timeout = setTimeout(later, wait);
            };
        },

        isValueNil: function(value) {
            return typeof value === 'undefined' || value === null;
        }
    };
});



// WEBPACK FOOTER //
// ./services/utils.js